import { api } from './apiClient';
import { API_ENDPOINTS } from '@/config';

export interface UploadVideoChunkRequest {
  candidateUId: string;
  interviewResultDataUId: string;
  isLastChunk: boolean;
  chunkIndex: number;
  totalChunks: number;
  fileName: string;
  videoFile: Blob;
}

interface UploadVideoChunkResponse {
  statusCode: number;
  message: string;
  data: UploadVideoChunkData | null;
  error: string | null;
}

export interface UploadVideoChunkData {
  uId: string;
  candidateUId: string;
  referenceUId: string | null;
  candidateName: string | null;
  status: string;
  questionAnswer: Array<{
    interviewType: string;
    question: string;
    answer: string;
    qaScore: number;
  }>;
  averageScore: number;
  isInterviewCompleted: boolean;
  interviewSummary: string;
  interviewRecording: {
    uploadedByName: string;
    uploadedByUId: string;
    url: string;
  };
  tabSwitchWarnings: number;
  faceDetectionWarnings: number;
  createdOn: string;
}

export const screenRecordingService = {
  async uploadVideoChunk(
    params: UploadVideoChunkRequest
  ): Promise<UploadVideoChunkResponse> {
    const formData = new FormData();
    formData.append('CandidateUId', params.candidateUId);
    formData.append('InterviewResultDataUId', params.interviewResultDataUId);
    formData.append('IsLastChunk', params.isLastChunk.toString());
    formData.append('ChunkIndex', params.chunkIndex.toString());
    formData.append('TotalChunks', params.totalChunks.toString());
    formData.append('FileName', params.fileName);
    formData.append('Videofile', params.videoFile, params.fileName);

    return api.interviewAgent.upload<UploadVideoChunkResponse>(
      API_ENDPOINTS.candidate.uploadCandidateInterviewVideo,
      formData
    );
  },
};
